import { updateObject, } from '../../utils/utility';

const initialState = {
    quoteDetails: {},
    pageNumber: 0,
    quoteViewList: [],
    totalElements: 0,
    totalPages: 0,
    companyList: [],
    regionList: [],
    countryList: [],
    legalEntityList: [],
    orderTypeList: [],
    ctResponsibleList: [],
    customerNameList: [],
    statusList: [],
    vendorList: [],
    revitalizeMappingFileName: "",
    revitalizeMappingFileStatus: false,
    revitalizePricingFileName: "",
    revitalizePricingFileStatus: false,
}

const setDirectCustomerCTInitialQuotes = (state = initialState, action) => {
    const {
        pageNumber, totalPages, totalElements, quoteViewList, companyList, regionList, countryList,
        legalEntityList, orderTypeList, ctResponsibleList, customerNameList, statusList, vendorList
    } = action.payload;
    return updateObject(state, {
        pageNumber,
        quoteViewList,
        totalElements,
        totalPages,
        companyList,
        regionList,
        countryList,
        legalEntityList,
        orderTypeList,
        ctResponsibleList,
        customerNameList,
        statusList,
        vendorList
    }
    );
};

const setDirectCustomerCTQuoteDetailsData = (state = initialState, action) => {
    return updateObject(state, {
        quoteDetails: action.payload
    });
};

const setMappingFileName = (state = initialState, action) => {
    return updateObject(state, {
        revitalizeMappingFileName: action.data
    });
}

const setMappingFileUploadStatus = (state = initialState, action) => {
    return updateObject(state, {
        revitalizeMappingFileStatus: action.data
    });
}

const setPricingFileName = (state = initialState, action) => {
    return updateObject(state, {
        revitalizePricingFileName: action.data
    });
}

const setPricingFileUploadStatus = (state = initialState, action) => {
    return updateObject(state, {
        revitalizePricingFileStatus: action.data
    });
}

const reducer = (state = initialState, action) => {
    if (action.type === "SET_DIRECT_CUSTOMER_CT_INITIAL_QUOTES") {
        return setDirectCustomerCTInitialQuotes(state, action);
    }
    else if (action.type === "SET_DIRECT_CUSTOMER_CT_INITIAL_QUOTE_DETAILS") {
        return setDirectCustomerCTQuoteDetailsData(state, action);
    } else if (action.type === "SET_MAPPING_FILE_NAME") {
        return setMappingFileName(state, action)
    } else if (action.type === "SET_MAPPING_FILE_UPLOAD_STATUS") {
        return setMappingFileUploadStatus(state, action)
    } else if (action.type === "SET_PRINCING_FILE_NAME") {
        return setPricingFileName(state, action)
    } else if (action.type === "SET_PRICING_FILE_UPLOAD_STATUS") {
        return setPricingFileUploadStatus(state, action)
    }
    return state;
}

export default reducer;